import React, { useContext } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard/";
import Tickets from "../pages/Tickets/";
import Login from "../pages/Login/";
import Connections from "../pages/Connections/";
import Settings from "../pages/Settings/";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts/";
import QuickAnswers from "../pages/QuickAnswers/";
import Queues from "../pages/Queues/";
import UserActivity from "../pages/UserActivity/";
import Kanban from "../pages/Kanban/";
import Tags from "../pages/Tags/";
import KeywordRules from "../pages/KeywordRules/";
import Reports from "../pages/Reports/";
import Webhooks from "../pages/Webhooks/";
import ServiceOrders from "../pages/ServiceOrders/";
import Quotes from "../pages/Quotes/";
import Receituarios from "../pages/Receituarios/";
import Adesivos from "../pages/Adesivos/";
import Catalog from "../pages/Catalog/";
import { AuthProvider, AuthContext } from "../context/Auth/AuthContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import { ThemeProvider } from "../context/DarkMode";
import ProtectedRoute from "./Route";
import { check } from "../components/Can";

// LGPD/SEC-002: bloqueia navegação direta a páginas restritas por perfil.
// A checagem real está no backend (isRole); aqui é reforço de UX.
const RoleRoute = ({ perform, children }) => {
  const { user } = useContext(AuthContext);
  if (!check(user?.profile, perform)) return <Navigate to="/" replace />;
  return children;
};

// Rotas privadas: ficam dentro do layout principal
const PrivateRoutes = () => (
  <ProtectedRoute>
    <WhatsAppsProvider>
      <LoggedInLayout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/tickets/:ticketId?" element={<Tickets />} />
          <Route path="/connections" element={<Connections />} />
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/users" element={<Users />} />
          <Route path="/quickAnswers" element={<QuickAnswers />} />
          <Route path="/Settings" element={<Settings />} />
          <Route path="/Queues" element={<Queues />} />
          <Route path="/user-activity" element={<UserActivity />} />
          <Route path="/kanban" element={<Kanban />} />
          <Route path="/tags" element={<Tags />} />
          <Route path="/keyword-rules" element={<KeywordRules />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/webhooks" element={<Webhooks />} />
          <Route
            path="/service-orders"
            element={
              <RoleRoute perform="financial-pages:view">
                <ServiceOrders />
              </RoleRoute>
            }
          />
          <Route
            path="/quotes"
            element={
              <RoleRoute perform="financial-pages:view">
                <Quotes />
              </RoleRoute>
            }
          />
          <Route
            path="/receituarios"
            element={
              <RoleRoute perform="financial-pages:view">
                <Receituarios />
              </RoleRoute>
            }
          />
          <Route
            path="/adesivos"
            element={
              <RoleRoute perform="financial-pages:view">
                <Adesivos />
              </RoleRoute>
            }
          />
          <Route path="/catalog" element={<Catalog />} />
        </Routes>
      </LoggedInLayout>
    </WhatsAppsProvider>
  </ProtectedRoute>
);

// Redireciona usuário já logado para fora das páginas públicas.
// Não bloqueia em loading: renderiza a página imediatamente e redireciona
// assim que isAuth resolver para true (evita tela branca inicial).
const PublicRoute = ({ element: Element }) => {
  const { isAuth } = useContext(AuthContext);
  return isAuth ? <Navigate to="/" replace /> : <Element />;
};

const AppRoutes = () => (
  <Routes>
    <Route path="/login" element={<PublicRoute element={Login} />} />
    <Route path="/*" element={<PrivateRoutes />} />
  </Routes>
);

const RouterApp = () => (
  <BrowserRouter>
    <AuthProvider>
      <ThemeProvider>
        <AppRoutes />
        <ToastContainer
          position="top-right"
          autoClose={3000}
          newestOnTop
          pauseOnHover
          limit={5}
        />
      </ThemeProvider>
    </AuthProvider>
  </BrowserRouter>
);

export default RouterApp;
